module.exports = __webpack_public_path__ + "static/media/galerija_2019 (24).bbe5d18c.jpg";